import { httpClient } from './http-client';
import { CONTRACT_ENDPOINTS } from '@/config/api';
import { BaseApi } from './base-api';
import type { ExtendedListParams } from '../types/search-criteria';
import type {
  Contract,
  ContractsList,
  CreateContractRequest,
  ContractDetails,
  ContractEndRequest,
  CustomInvoiceRequest,
} from '../types/contract';

export class ContractsApi extends BaseApi {

  static async getContracts(params?: ExtendedListParams): Promise<ContractsList> {
    return this.getList<Contract>(CONTRACT_ENDPOINTS.CONTRACTS, params);
  }

  static async getContractById(contractId: number): Promise<Contract> {
    return httpClient.get<Contract>(CONTRACT_ENDPOINTS.CONTRACT_BY_ID(contractId));
  }

  static async createContract(data: CreateContractRequest): Promise<Contract> {
    return httpClient.post<Contract>(CONTRACT_ENDPOINTS.CREATE_CONTRACT, data);
  }

  static async updateContractRecurrent(contractId: number): Promise<Contract> {
    return httpClient.put<Contract>(CONTRACT_ENDPOINTS.CONTRACT_RECURRENT(contractId));
  }

  static async disableContractRecurrent(contractId: number): Promise<Contract> {
    return httpClient.delete<Contract>(CONTRACT_ENDPOINTS.CONTRACT_RECURRENT(contractId));
  }

  static async getContractDetails(contractId: number): Promise<ContractDetails> {
    return httpClient.get<ContractDetails>(CONTRACT_ENDPOINTS.CONTRACT_DETAILS(contractId));
  }

  static async requestInvoice(contractId: number, data: CustomInvoiceRequest): Promise<void> {
    return httpClient.post<void>(CONTRACT_ENDPOINTS.CONTRACT_INVOICE_REQUEST(contractId), data);
  }

  static async requestEnd(contractId: number, data: ContractEndRequest): Promise<void> {
    return httpClient.post<void>(CONTRACT_ENDPOINTS.CONTRACT_END_REQUEST(contractId), data);
  }
}
